import React, { Component } from "react";

import Notifications from "@/components/Patient/Profile/Notifications";
import { patientRequests } from "@/api/(requests)/patient";

class PatientNotifications extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profileData: null,
    };
  }

  componentDidMount() {
    this.getProfile();
  }

  getProfile = async () => {
    try {
      let response = await patientRequests.fetch_profile({ context: { showLoader: false } });

      this.setState({
        profileData: response && response.user,
      });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    const { profileData } = this.state;

    return <>{profileData && <Notifications profileData={profileData} />}</>;
  }
}

export default PatientNotifications;
